import { PartnerOnboardingItemStatus, Transport } from 'src/app/partnerportal/models/partner-onboarding';

export class PossibleDocumentType {
    Id: number | null;
    Name: string;
    Formats: Format[];

    constructor(source?: Partial<PossibleDocumentType>) {
    if (source) {
        Object.assign(this, source);
    }
    }
}

export class SelectedDocumentType {
    Id: number | null;
    Name: string;
    Format: Format;
    Transport: Transport;
    Status: PartnerOnboardingItemStatus;
    ConversationId: string;

    constructor(source?: Partial<SelectedDocumentType>) {
        if (source) {
            Object.assign(this, source);
        }
    }
}

export class Format {
    Id: number | null;
    Name: string;
}



export class FormDocumentType {
    Id: number | null;
    Name: string;
    SelectedFormat: Format;
    PossibleFormats: Format[];
    CustomFormatName: string;
    Selected: boolean;
    Transport: Transport;
    Status: PartnerOnboardingItemStatus;
    ConversationId: string;

    constructor(source?: Partial<FormDocumentType>) {
        if (source) {
            Object.assign(this, source);
        }
    }
}

export class FormCustomDocumentType {
    Name: string;
    Format: string;
    Transport: Transport;
    Status: PartnerOnboardingItemStatus;
    ConversationId: string;

    constructor(source?: Partial<FormCustomDocumentType>) {
        if (source) {
            Object.assign(this, source);
        }
    }
}

